import React from "react";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import Shimmer from "./Shimmer";
import "./Details.css";

function Details() {
  const { id } = useParams();
  const [details, setDetails] = useState(null);

  useEffect(() => {
    getTop().then((data) => setDetails(data));
    async function getTop() {
      const url = `https://api.coinlore.net/api/ticker/?id=${id}`;
      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      } catch (err) {
        console.error(err);
      }
    }
  }, []);

  if (!details)
    return (
      <div className="details">
        <div className="loading-crypto-change"></div>
        <div className="loading-crypto-change"></div>
        <div className="loading-crypto-change"></div>
        <div className="loading-crypto-change"></div>
        <Shimmer />
      </div>
    );


  return (
    <div className="details">
      {details.map((item) => {
        return (
          <ul className="center">
            <li className="cryptoDetails" key="1">{item.name}</li>

            <li className="cryptoDetails" key="2">
              ${item.price_usd} <a href="/" className="currency">USD</a>
            </li>

            {item.percent_change_1h.indexOf("-") === -1 ? (
              <li className="name" key="3">
                Percent Change 1h:{" "}
                <i className="greenChange material-icons">arrow_drop_up</i>
                <a href="/" className="greenChange">
                  {item.percent_change_1h}%
                </a>
              </li>
            ) : (
              <li className="name" key="3">
                Percent Change 1h:{" "}
                <i class="redChange material-icons">arrow_drop_down</i>
                <a href="/" className="redChange">
                  {item.percent_change_1h}%
                </a>
              </li>
            )}

            {item.percent_change_24h.indexOf("-") === -1 ? (
              <li className="name" key="4">
                Percent Change 24h:{" "}
                <i class="greenChange material-icons">arrow_drop_up</i>
                <a href="/" className="greenChange">
                  {item.percent_change_24h}%
                </a>
              </li>
            ) : (
              <li className="name" key="4">
                Percent Change 24h:{" "}
                <i class="redChange material-icons">arrow_drop_down</i>
                <a href="/" className="redChange">
                  {item.percent_change_24h}%
                </a>
              </li>
            )}

            {item.percent_change_7d.indexOf("-") === -1 ? (
              <li className="name" key="5">
                Percent Change 7d:{" "}
                <i class="greenChange material-icons">arrow_drop_up</i>
                <a href="/" className="greenChange">
                  {item.percent_change_7d}%
                </a>
              </li>
            ) : (
              <li className="name" key="5">
                Percent Change 7d:{" "}
                <i class="redChange material-icons">arrow_drop_down</i>
                <a href="/" className="redChange">
                  {item.percent_change_7d}%
                </a>
              </li>
            )}
          </ul>
        );
      })}
    </div>
  );
}

export default Details;
